const React = require("react");
/*const auth = require("../../Authenticator.js");*/
const server = require("../../Server.js");


function getLegalCounselFile(url) {
    return function () {
        server.Get(url).then((res) => {
            res.blob().then((blob) => {
                var url = window.URL.createObjectURL(blob);
                var a = window.document.createElement('a');
                a.href = url;
                a.download = "LegalCounselFile.csv";
                a.click();
            });
        });
    };
}

const LegalCounselAssignmentsForm = React.createClass({
    render() {
        return (<div>
            Legal Counsel store assignments file:&nbsp;
            <a href="javascript:void(0)" target="_blank" onClick={getLegalCounselFile(this.props.SampleFileURL)}>Click here to download</a>
        </div>);
    }
});

module.exports = LegalCounselAssignmentsForm;


// WEBPACK FOOTER //
// ./src/components/metadata/LegalCounselAssignmentsForm.jsx